export class RequestAuthenticationSettings {
   public static readonly type = '[Authentication Settings] Request Authentication Settings';

   constructor() {}
}
